module.exports = __webpack_public_path__ + "static/img/vision_saas.a788ac2b.png";